import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import TestimonialImg from "../assets/images/testimonials.png";

const TestimonialsSlider = () => {
  // Slider settings for react-slick with center mode enabled
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    centerMode: true,
    centerPadding: "0", // Ensures the active slide is centered fully
  };

  // Dummy testimonial data
  const testimonialsData = [
    {
      id: 1,
      name: "John Doe",
      image: TestimonialImg,
      testimonial:
        "Working with Globelink has been an absolute game changer for our recruitment process. They truly took the time to understand our company's unique culture and hiring needs. The candidates they provided were not only highly qualified but also a perfect fit for our team. We appreciate their thorough candidate screening and dedication to finding the right talent. The flexibility of both temporary and permanent staffing solutions has made a huge difference to our business. Highly recommended!",
    },
    {
      id: 2,
      name: "Jane Smith",
      image: TestimonialImg,
      testimonial:
        "Working with Globelink has been an absolute game changer for our recruitment process. They truly took the time to understand our company's unique culture and hiring needs. The candidates they provided were not only highly qualified but also a perfect fit for our team. We appreciate their thorough candidate screening and dedication to finding the right talent. The flexibility of both temporary and permanent staffing solutions has made a huge difference to our business. Highly recommended!",
    },
    {
      id: 3,
      name: "Jane Smith",
      image: TestimonialImg,
      testimonial:
        "Working with Globelink has been an absolute game changer for our recruitment process. They truly took the time to understand our company's unique culture and hiring needs. The candidates they provided were not only highly qualified but also a perfect fit for our team. We appreciate their thorough candidate screening and dedication to finding the right talent. The flexibility of both temporary and permanent staffing solutions has made a huge difference to our business. Highly recommended!",
    },
    // Add more testimonials as needed
  ];

  return (
    <div className="w-full min-h-[600px] bg-[#F8F8F8] flex flex-col items-center justify-center gap-6 px-4 py-10 md:py-0">
      <div className="w-full max-w-2xl">
        <p className="text-sm md:text-base text-center font-semibold">
          Happy Customers
        </p>
        <h3 className="text-[#1A2942] text-2xl md:text-3xl text-center font-semibold mb-2 mt-4">
          Testimonials
        </h3>
        <Slider {...settings}>
          {testimonialsData.map((item) => (
            <div
              key={item.id}
              className="flex flex-col md:flex-row items-center justify-center p-6 gap-4"
            >
              {/* Centering the image container */}
              <div className="w-[80px] h-[80px] md:w-[100px] md:h-[100px] rounded-full overflow-hidden flex items-center justify-center">
                <img
                  src={item.image}
                  alt={item.name}
                  className="object-cover w-full h-full"
                />
              </div>
              <p className="text-sm md:text-base text-center font-sans text-[#000000] px-4 md:px-8 leading-6">
                "{item.testimonial}"
              </p>
              {/* Uncomment if you want to display the name */}
              {/* <p className="text-xs mt-4 text-gray-600">- {item.name}</p> */}
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default TestimonialsSlider;
